import { Route, Routes as RouterRoutes } from 'react-router-dom';
import LandingPage from './pages/LandingPage';
import MentorsOverviewPage from './pages/MentorsOverviewPage';
import ResponsivePreview from './pages/ResponsivePreview';

const Routes = () => {
  return (
    <RouterRoutes>
      <Route path="/" element={<LandingPage />} />
      <Route path="/mentors" element={<MentorsOverviewPage />} />
      <Route path="/responsive-preview" element={<ResponsivePreview />} />
    </RouterRoutes>
  );
};

export default Routes;
